var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player"},[_c('div',{staticClass:"player_name"},[_vm._v(_vm._s(_vm.video.name))]),_vm._v(" "),_c('video',{staticClass:"video-js vjs-default-skin vjs-big-play-centered",staticStyle:{"width":"100%"},attrs:{"id":"A"+_vm.video.index}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-492d6762","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nursingRoom/playVideo.vue
// module id = null
// module chunks = 